import axios from 'axios';
import { useCallback, useEffect, useMemo, useState } from 'react';
import Form, { Validations } from '../../../../../components/Form';
import useRequest from '../../../../../hooks/useRequest';
import { ControlItem } from '../../../types';
import { formatObjectFields, getFieldsFromObject } from '../../helpers';

import ServicePaths from '../../../../../bridge/utils/ServicePaths';

const EditBotForm = () => {
  const [botId, setBotId] = useState<string | undefined>();
  const [errors, setErrors] = useState<Record<string, Validations>>({});
  const [canFetchBot, setCanFetchBot] = useState(false);
  const [bot, setBot] = useState<Record<string, any> | undefined>();
  const [formMessage, setFormMessage] = useState();
  const [isLoading, setIsLoading] = useState(false);

  const params = useMemo(() => ({ botId }), [botId]);
  const options = useMemo(() => ({ shouldFetch: canFetchBot }), [canFetchBot]);
  const { data: botData } = useRequest(
    ServicePaths.CONTROL.GetRawBot,
    params,
    options,
  );

  useEffect(() => {
    setBot(botData);
  }, [botData]);

  const checkBotIdValidation = useCallback(() => {
    /** botId can not be empty */

    setErrors({});

    if (typeof botId !== 'undefined' && botId?.length === 0) {
      setErrors((prev) => ({
        ...prev,
        botId: Validations.Required,
      }));
    }

    return true;
  }, [botId]);

  const handleGetBotSubmit = useCallback(() => {
    const canContinue = checkBotIdValidation();

    if (!canContinue) {
      setIsLoading(false);
      return;
    }

    setCanFetchBot(true);
  }, [checkBotIdValidation]);

  const handleSubmit = useCallback(async () => {
    if (!bot) {
      return;
    }

    setIsLoading(true);

    /** Edit don't have validation @TODO */

    const { data } = await axios({
      method: 'POST',
      url: ServicePaths.CONTROL.EditBot,
      params: {
        bot: formatObjectFields(bot),
      },
    });

    setIsLoading(false);
    setFormMessage(data);
  }, [bot]);

  const botDataConfig = useMemo(() => {
    return {
      title: ControlItem.EditBot,
      fields: [
        {
          label: 'Bot Id',
          value: botId,
          handleValueChange: setBotId,
          error: errors.userId,
        },
      ],
      handleSubmit: handleGetBotSubmit,
    };
  }, [botId, errors.userId, handleGetBotSubmit]);

  const config = useMemo(() => {
    if (!bot) {
      return null;
    }

    /** Loop over values */
    const fields = getFieldsFromObject(bot, errors, setBot);

    return {
      title: ControlItem.EditBot,
      formMessage,
      fields: fields,
      handleSubmit,
      isLoading,
    };
  }, [errors, formMessage, handleSubmit, isLoading, bot]);

  if (!botData) {
    return <Form config={botDataConfig} />;
  }

  if (!config) {
    return null;
  }

  return <Form config={config} />;
};

export default EditBotForm;
